import api from './client';

export interface Task {
  id: number;
  type: string;
  title: string;
  status: 'pending' | 'running' | 'done' | 'error';
  result_json: Record<string, any> | null;
  error_message: string | null;
  seen_at: string | null;
  created_at: string;
  updated_at: string;
}

export async function getTasks(): Promise<Task[]> {
  const res = await api.get('/tasks');
  return res.data;
}

export async function markSeen(id: number): Promise<void> {
  await api.put(`/tasks/${id}/seen`);
}

export async function markAllSeen(): Promise<void> {
  await api.put('/tasks/seen-all');
}

export async function dismissTask(id: number): Promise<void> {
  await api.put(`/tasks/${id}/dismiss`);
}
